import { otsBaseApi } from "../../ots-api";
import { Company } from "../../../model/company";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({ addTagTypes: ["Companies"] });

export const companyApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCompanies: builder.query<Company[], string | undefined>({
      query: (regionId) => ({
        url: `/company/all`,
        method: "GET",
        params: regionId ? { regionId: regionId } : undefined
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({ id }) => ({ type: "Companies", id } as const)),
            { type: "Companies", id: "LIST" }
          ];
        } else {
          return [{ type: "Companies", id: "LIST" }];
        }
      }
    }),
    getCompany: builder.query<Company, string>({
      query: (id) => ({
        url: `/company/${id}`,
        method: "GET"
      }),
      providesTags: (result, error, id) => [{ type: "Companies", id }]
    })
  })
});

export const {
  useGetAllCompaniesQuery,
  useGetCompanyQuery
} = companyApi;
